import { render, staticRenderFns } from "./UbicacionesUpdate.vue?vue&type=template&id=4452705a&"
import script from "./UbicacionesUpdate.vue?vue&type=script&lang=js&"
export * from "./UbicacionesUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports